import { getSentryClient } from '../sentry';

interface ErrorProps {
	error: unknown;
	functionName: string;
	traceId?: string | null;
}

const error = async ({ error, functionName, traceId }: ErrorProps): Promise<void> => {
	try {
		const SentryClient = await getSentryClient();

		if (!SentryClient) {
			return;
		}

		SentryClient.withScope((scope) => {
			scope.setTag('packageName', '@atlassian/search-ai');
			scope.setFingerprint([`functionName: ${functionName}`]);
			if (traceId) {
				scope.setTag('traceId', traceId);
			}
			SentryClient.captureException(error, scope);
		});
	} catch (error) {
		// When there was an error with Sentry, just output to console
		// eslint-disable-next-line no-console
		console.error(error);
	}
};

export const logger = {
	error,
};
